import React from 'react'

function FloatingCharacter(props) {
  return (
    <div className='absolute-val'>{props.value}</div>
  )
}

export default FloatingCharacter 